import service from "@/services/statistics";

const statistics = {
  namespaced: true,
  state: {
    e_meeting_id: null,
    items: [],
    participation_summary: {},
  },
  getters: {
    getItems: (state) => (id) => {
      return state.items.find(
        (agenda_item) => agenda_item.e_meeting_agenda_item_id === Number(id)
      );
    },
    getSummary: (state) => {
      return state.participation_summary;
    },
  },
  mutations: {
    updateState(state, value) {
      state.items = value.agenda_items;
      state.e_meeting_id = value.e_meeting_id;
      state.participation_summary = value.participation_summary;
    },
    clearStatistics(state) {
      state.e_meeting_id = null;
      state.items = [];
      state.participation_summary = {};
    },
  },
  actions: {
    async fetchStatistics({ commit }, id) {
      commit("clearStatistics");
      try {
        const statistics = await service.getStatistics(id);
        commit("updateState", statistics);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};

export default statistics;
